// extracted by mini-css-extract-plugin
export default {"header":"Header_header__AWKPi","touch":"Header_touch__wbxFa","content":"Header_content__jTCUb"};